<template>
  <div class="examine">
    <div v-if="status == 0">
      <div class="title">开通收款账户申请已提交，预计会在1-3个工作日内完成审核，请耐心等待</div>
      <van-cell class="cell" title="当前审核状态" value="审核中" size="large" />
      <div class="link">如果有问题请联系客服</div>
    </div>
    <div v-else-if="status == 2">
      <div class="title">开通收款账户申请已提交，预计会在1-3个工作日内完成审核，请耐心等待</div>
      <van-cell class="cell" title="当前审核状态" value="审核失败" size="large" />
      <div class="desc">失败原因:{{ data.auditDesc }}</div>
      <div class="form-bottom">
        <van-button type="primary" color="#0B6CE3" class="button" @click="createShop"
          >重新开通收款账户</van-button
        >
      </div>
      <div class="link">如果有问题请联系客服</div>
    </div>
  </div>
</template>

<script>
import { accountView } from '@/api/capital';
export default {
  data() {
    return {
      status: null,
      data: {
        auditDesc: null,
      },
    };
  },
  created() {
    this.status = this.$route.params.id;
    this.init();
  },
  methods: {
    createShop() {
      this.$router.replace('/capital/enterprise/' + this.status);
    },
    init() {
      accountView().then(res => {
        this.data = res.data;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.examine {
  font-size: 14px;
  color: #333;
  background: #fff;
  height: 100vh;
  .cell::after {
    border-bottom: none;
  }
  .form-bottom {
    padding: 20px;
    text-align: center;
  }
  .button {
    width: 90vw;
  }
  .title {
    padding: 20px;
  }
  .link {
    padding-left: 20px;
    font-size: 12px;
    color: blue;
  }
  .desc {
    padding-left: 16px;
  }
}
</style>
